import { render, staticRenderFns } from "./AccountTransfers.vue?vue&type=template&id=13590629&"
import script from "./AccountTransfers.vue?vue&type=script&lang=js&"
export * from "./AccountTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports